export const ageMethod = "age nearest";
export const gateway = "https://qat-mello-api.link-nonprod.wawanesalife.com";
export const assets = "https://qat-assets.link-nonprod.wawanesalife.com/brokers/mello";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJtZWxsbyIsIm5hbWUiOiJtZWxsbyIsImlhdCI6MTc4MDU4MjgzMywiZXhwIjoxOTM4MzcwODMzfQ.mFBB6rOzlULwELlj52e9-l3YozzpsnXAp7JXr2h3bN8";
export const brokerConfig = {
	enabled: "yes",
	"split": '0.6'
};
export const brokerBranding = {
	"qat-mello-shopper.link-nonprod.wawanesalife.com": {
		a: {
			approve_company: "Link Platform",
			approve_user: "link_mello",
			brands: [
				"qat-mello-shopper.link-nonprod.wawanesalife.com",
			],
			broker: "mello",
			broker_formatted_name: "Mello Insurance",
			email: "kayla@melloinsurance.ca",
			environment: "qat",
			environment_id: "qat",
			layout: "modern",
			logoPosition: "menu",
			menuPhone: "button",
			phone: "306-283-1236",
			photos: [
				"photo1.jpg",
				"photo2.jpg",
				"photo3.jpg",
				"photo4.jpg",
				"photo5.jpg",
				"photo6.jpg",
			],
			privacyLink: "https://melloinsurance.ca/privacy-policy/",
			tagline: "Stay Mello",
			website: "https://melloinsurance.ca/",
			scope: "mello#branding#qat-mello-shopper.link-nonprod.wawanesalife.com#a",
			ab: "a",
			logo: "a.png",
			brand_name: "qat-mello-shopper.link-nonprod.wawanesalife.com",
		},
		b: {
			approve_company: "Link Platform",
			approve_user: "link_mello",
			brands: [
				"qat-mello-shopper.link-nonprod.wawanesalife.com",
			],
			broker: "mello",
			broker_formatted_name: "Mello Insurance",
			email: "kayla@melloinsurance.ca",
			environment: "qat",
			environment_id: "qat",
			layout: "modern",
			logoPosition: "menu",
			menuPhone: "button",
			phone: "306-283-1236",
			photos: [
				"photo1.jpg",
				"photo2.jpg",
				"photo3.jpg",
				"photo4.jpg",
				"photo5.jpg",
				"photo6.jpg",
			],
			privacyLink: "https://melloinsurance.ca/privacy-policy/",
			tagline: "Stay Mello",
			website: "https://melloinsurance.ca/",
			scope: "mello#branding#qat-mello-shopper.link-nonprod.wawanesalife.com#b",
			ab: "b",
			logo: "b.png",
			brand_name: "qat-mello-shopper.link-nonprod.wawanesalife.com",
		},
	},
};

//updated on Thu Jun 04 2026 14:20:33 GMT+0000 (Coordinated Universal Time)
